import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { apiClient } from "../../../api/httpClient";
import { setPgId } from "../../../store/slices/pgSlice";
import { getPgHomeVariantConfig } from "../pgHomeConfig";
import { useHomeDataBase } from "./useHomeDataBase";

export const PG_HOME_PAGE_SIZE = 5;

/**
 * PG / PG-contact home dashboards (no JSX).
 * @param {'guardianUser'|'contact'} variant
 */
export function usePgHomeData(variant = "guardianUser") {
  const cfg = getPgHomeVariantConfig(variant);
  const auth = useSelector((state) => state.auth);
  const authContact = useSelector((state) => state.auth);
  const pgIdFromStore = useSelector((state) => state.pg?.pgId);
  const dispatch = useDispatch();
  const isContact = variant === "contact";

  const [loading, setLoading] = useState(true);
  const [pg, setPg] = useState(null);

  useEffect(() => {
    if (isContact || cfg.pgIdSource === "auth") {
      setPg(authContact.pg_id || "");
      setLoading(false);
      return;
    }
    if (pgIdFromStore !== undefined && pgIdFromStore !== null && pgIdFromStore !== "") {
      setPg(pgIdFromStore);
      setLoading(false);
      return;
    }
    const fetchPgId = async () => {
      try {
        const responseUser = await apiClient(
          `/professional-guardian-user-id/${auth.user.id}`,
          "GET"
        );
        setPg(responseUser.pg_id);
        dispatch(setPgId(responseUser.pg_id));
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };
    fetchPgId();
  }, [auth.user?.id, dispatch, isContact, authContact.pg_id, cfg.pgIdSource, pgIdFromStore]);

  const homeData = useHomeDataBase({
    userId: auth?.user?.id,
    pgId: pg,
    enabled: Boolean(pg),
    appendIndemnityFormFields: (form, { pgId: resolvedPgId }) => {
      if (resolvedPgId) form.append("professional_guardian_id", String(resolvedPgId));
      const uid = isContact ? authContact.user?.id : auth?.user?.id;
      if (uid) form.append("requester_id", String(uid));
    },
  });

  return {
    cfg,
    variant,
    isContact,
    pg,
    loading,
    drafts: homeData.drafts,
    activity: homeData.activity,
    indemnity: homeData.indemnity,
    dialogs: homeData.dialogs,
    compliance: homeData.compliance,
  };
}
